export const sampleHar = {
  log: {
    version: "1.2",
    creator: {
      name: "HARScope synthetic trace",
      version: "0.1.0"
    },
    pages: [
      {
        startedDateTime: "2026-06-14T02:12:01.000Z",
        id: "page_1",
        title: "Checkout support trace",
        pageTimings: {
          onContentLoad: 1480,
          onLoad: 3220
        }
      }
    ],
    entries: [
      {
        pageref: "page_1",
        startedDateTime: "2026-06-14T02:12:01.000Z",
        time: 338,
        request: {
          method: "GET",
          url: "https://shop.example.com/checkout?session_token=abc123-sensitive",
          httpVersion: "HTTP/2",
          headers: [
            { name: "Accept", value: "text/html" },
            { name: "Cookie", value: "cart=42; session=redacted-sample" }
          ],
          queryString: [{ name: "session_token", value: "abc123-sensitive" }],
          cookies: [],
          headersSize: 420,
          bodySize: 0
        },
        response: {
          status: 200,
          statusText: "OK",
          httpVersion: "HTTP/2",
          headers: [
            { name: "content-type", value: "text/html; charset=utf-8" },
            { name: "cache-control", value: "no-store" },
            { name: "server", value: "cloudflare" }
          ],
          cookies: [],
          content: {
            size: 18422,
            mimeType: "text/html"
          },
          redirectURL: "",
          headersSize: 512,
          bodySize: 18422
        },
        cache: {},
        timings: {
          blocked: 3,
          dns: 12,
          connect: 40,
          ssl: 28,
          send: 4,
          wait: 212,
          receive: 67
        }
      },
      {
        pageref: "page_1",
        startedDateTime: "2026-06-14T02:12:01.170Z",
        time: 184,
        request: {
          method: "GET",
          url: "https://shop.example.com/assets/app.4f9d.js",
          httpVersion: "HTTP/2",
          headers: [{ name: "Accept", value: "application/javascript" }],
          queryString: [],
          headersSize: 280,
          bodySize: 0
        },
        response: {
          status: 200,
          statusText: "OK",
          headers: [
            { name: "content-type", value: "application/javascript" },
            { name: "cf-cache-status", value: "HIT" },
            { name: "content-encoding", value: "br" }
          ],
          content: {
            size: 228000,
            mimeType: "application/javascript"
          },
          headersSize: 360,
          bodySize: 65420
        },
        cache: {},
        timings: {
          blocked: 1,
          dns: 0,
          connect: 0,
          ssl: 0,
          send: 3,
          wait: 86,
          receive: 94
        }
      },
      {
        pageref: "page_1",
        startedDateTime: "2026-06-14T02:12:01.260Z",
        time: 2860,
        request: {
          method: "GET",
          url: "https://api.shop.example.com/v1/cart",
          headers: [{ name: "Authorization", value: "Bearer eyJhbGciOiJIUzI1NiJ9.eyJ1c2VyIjoiNDIifQ.signatureSample" }],
          queryString: [],
          headersSize: 392,
          bodySize: 0
        },
        response: {
          status: 500,
          statusText: "Internal Server Error",
          headers: [
            { name: "content-type", value: "application/json" },
            { name: "cache-control", value: "no-store" }
          ],
          content: {
            size: 420,
            mimeType: "application/json"
          },
          headersSize: 288,
          bodySize: 420
        },
        cache: {},
        timings: {
          blocked: 2,
          dns: 28,
          connect: 96,
          ssl: 64,
          send: 6,
          wait: 2480,
          receive: 248
        }
      },
      {
        pageref: "page_1",
        startedDateTime: "2026-06-14T02:12:01.420Z",
        time: 116,
        request: {
          method: "GET",
          url: "https://cdn.example-cdn.com/fonts/atlas.woff2",
          headers: [{ name: "Accept", value: "font/woff2" }],
          queryString: [],
          headersSize: 260,
          bodySize: 0
        },
        response: {
          status: 200,
          statusText: "OK",
          headers: [
            { name: "content-type", value: "font/woff2" },
            { name: "cache-control", value: "public, max-age=31536000" }
          ],
          content: {
            size: 74400,
            mimeType: "font/woff2"
          },
          headersSize: 320,
          bodySize: 74400
        },
        cache: {},
        timings: {
          blocked: 1,
          dns: 8,
          connect: 24,
          ssl: 19,
          send: 3,
          wait: 38,
          receive: 23
        }
      },
      {
        pageref: "page_1",
        startedDateTime: "2026-06-14T02:12:01.530Z",
        time: 936,
        request: {
          method: "GET",
          url: "https://images.example-cdn.com/products/hero-large.webp",
          headers: [{ name: "Accept", value: "image/avif,image/webp,image/apng,image/svg+xml,image/*,*/*" }],
          queryString: [],
          headersSize: 320,
          bodySize: 0
        },
        response: {
          status: 200,
          statusText: "OK",
          headers: [
            { name: "content-type", value: "image/webp" },
            { name: "x-cache", value: "MISS" }
          ],
          content: {
            size: 1750000,
            mimeType: "image/webp"
          },
          headersSize: 340,
          bodySize: 1750000
        },
        cache: {},
        timings: {
          blocked: 2,
          dns: 10,
          connect: 32,
          ssl: 24,
          send: 4,
          wait: 270,
          receive: 618
        }
      },
      {
        pageref: "page_1",
        startedDateTime: "2026-06-14T02:12:01.720Z",
        time: 642,
        request: {
          method: "POST",
          url: "https://payments.example-pay.com/v2/intent?client_secret=pay_secret_123",
          headers: [
            { name: "content-type", value: "application/json" },
            { name: "x-api-key", value: "sample-key-value" }
          ],
          queryString: [{ name: "client_secret", value: "pay_secret_123" }],
          postData: {
            mimeType: "application/json",
            text: "{\"cardLast4\":\"4242\",\"accessToken\":\"access_token_sample\"}",
            params: []
          },
          headersSize: 580,
          bodySize: 66
        },
        response: {
          status: 403,
          statusText: "Forbidden",
          headers: [
            { name: "content-type", value: "application/json" },
            { name: "set-cookie", value: "pay_trace=sample; HttpOnly" }
          ],
          content: {
            size: 620,
            mimeType: "application/json"
          },
          headersSize: 420,
          bodySize: 620
        },
        cache: {},
        timings: {
          blocked: 2,
          dns: 26,
          connect: 84,
          ssl: 60,
          send: 10,
          wait: 394,
          receive: 66
        }
      },
      {
        pageref: "page_1",
        startedDateTime: "2026-06-14T02:12:01.880Z",
        time: 88,
        request: {
          method: "GET",
          url: "https://www.googletagmanager.com/gtm.js?id=GTM-EXAMPLE",
          headers: [{ name: "Accept", value: "application/javascript" }],
          queryString: [{ name: "id", value: "GTM-EXAMPLE" }],
          headersSize: 260,
          bodySize: 0
        },
        response: {
          status: 200,
          statusText: "OK",
          headers: [
            { name: "content-type", value: "application/javascript" },
            { name: "cache-control", value: "private, max-age=900" }
          ],
          content: {
            size: 112000,
            mimeType: "application/javascript"
          },
          headersSize: 340,
          bodySize: 41200
        },
        cache: {},
        timings: {
          blocked: 1,
          dns: 7,
          connect: 20,
          ssl: 15,
          send: 2,
          wait: 36,
          receive: 22
        }
      },
      {
        pageref: "page_1",
        startedDateTime: "2026-06-14T02:12:02.040Z",
        time: 1510,
        request: {
          method: "GET",
          url: "http://legacy.example-cdn.com/promo.js",
          headers: [{ name: "Accept", value: "application/javascript" }],
          queryString: [],
          headersSize: 240,
          bodySize: 0
        },
        response: {
          status: 200,
          statusText: "OK",
          headers: [{ name: "content-type", value: "application/javascript" }],
          content: {
            size: 38200,
            mimeType: "application/javascript"
          },
          headersSize: 190,
          bodySize: 38200
        },
        cache: {},
        timings: {
          blocked: 3,
          dns: 80,
          connect: 240,
          ssl: 0,
          send: 5,
          wait: 972,
          receive: 210
        }
      }
    ]
  }
};

export const sampleHarText = JSON.stringify(sampleHar, null, 2);
